<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :modelNameSingular="modelNameSingular"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readTitle="readTitle"
    :readOnly="readOnly"
    :isTextButton="isTextButton"
    :textButton="textButton"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readTitle: {
      type: String,
      default: "Visualização de Transferência"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_TRANSFER_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.transfer;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(transfer) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_TRANSFER_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(transfer, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateTransfer.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_TRANSFER_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      transfer(id: $id) {
        id
        value
        date
        sourceBankAccount {
          id
          name
          currentBalance
          bankAccountType {
          	id
            name
          }
        }
        sourceBankAccountId
        targetBankAccount {
          id
          name
          currentBalance
          bankAccountType {
          	id
            name
          }
        }
        targetBankAccountId
        validations
      }
      allBankAccounts {
        id
        name
        nameWithBank
        currentBalance
        accountNumber
        agencyNumber
        bankAccountType {
          id
          name
        }
        bank {
          id
          name
          nameWithCode
        }
      }
    }
  }
`;

const UPDATE_TRANSFER_MUTATION = gql `
  mutation($input: TransferUpdateInputObject!) {
    updateTransfer(input: $input) {
      transfer {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
